var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.399,
    height: 9.468,
    viewBox: "0 0 10.399 9.468",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_228",
    "data-name": "Group 228",
    transform: "translate(0 -20.609)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_227",
    "data-name": "Group 227",
    transform: "translate(0 20.609)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_226",
    "data-name": "Group 226",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    d: "M.578,89.916H6.4V88.761H.578a.578.578,0,0,0,0,1.155Z",
    transform: "translate(0 -87.221)",
    fill: "#2d3040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    "data-name": "Path 642",
    d: "M.578,192.473H6.4v-1.155H.578a.578.578,0,0,0,0,1.155Z",
    transform: "translate(0 -187.46)",
    fill: "#2d3040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    "data-name": "Path 643",
    d: "M.578,293.874h0a.578.578,0,1,0,0,1.155H4.621a1.427,1.427,0,0,1,.122-1.155Z",
    transform: "translate(0 -287.697)",
    fill: "#2d3040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644",
    "data-name": "Path 644",
    d: "M236.984,26.983a.73.73,0,0,0-1.033,0l-.6.6V21.339a.73.73,0,0,0-1.461,0v6.243l-.6-.6a.73.73,0,0,0-1.033,1.033l1.847,1.847a.731.731,0,0,0,1.033,0l1.847-1.847A.73.73,0,0,0,236.984,26.983Z",
    transform: "translate(-226.798 -20.609)",
    fill: "#2d3040"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.aa072f7b0a95dd3e57e2e2f121d22220.svg";
export { ForwardRef as ReactComponent };